import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { HistoryOfChinese } from './pages/HistoryOfChinese';
import { FAQ } from './pages/FAQ';
import { Contact } from './pages/Contact';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { AboutUs } from './pages/AboutUs';
import { KungPaoChicken } from './pages/recipes/KungPaoChicken';
import { MapoTofu } from './pages/recipes/MapoTofu';
import { DimSum } from './pages/recipes/DimSum';
import { ChowMein } from './pages/recipes/ChowMein';
import { FriedRice } from './pages/recipes/FriedRice';
import { HotPot } from './pages/recipes/HotPot';
import { BeefAndBroccoli } from './pages/recipes/BeefAndBroccoli';
import { SweetAndSourPork } from './pages/recipes/SweetAndSourPork';
import { EggFooYoung } from './pages/recipes/EggFooYoung';
import { ChineseDumplings } from './pages/recipes/ChineseDumplings';
import { GeneralTsoChicken } from './pages/recipes/GeneralTsoChicken';
import { ChineseFoodFacts } from './pages/ChineseFoodFacts';
import { ChineseFoodQuiz } from './pages/ChineseFoodQuiz';
import { NewYork } from './pages/cities/NewYork';
import { SanFrancisco } from './pages/cities/SanFrancisco';
import { LosAngeles } from './pages/cities/LosAngeles';
import { Chicago } from './pages/cities/Chicago';
import { Houston } from './pages/cities/Houston';
import { Seattle } from './pages/cities/Seattle';
import { Boston } from './pages/cities/Boston';
import { Philadelphia } from './pages/cities/Philadelphia';
import { LasVegas } from './pages/cities/LasVegas';
import { Washington } from './pages/cities/Washington';

declare global {
  interface Window {
    google?: typeof google;
    initMapCallback?: () => void;
  }
}

const App = () => {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/history" element={<HistoryOfChinese />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/chinese-food-facts" element={<ChineseFoodFacts />} />
        <Route path="/chinese-food-quiz" element={<ChineseFoodQuiz />} />
        <Route path="/recipes/kung-pao-chicken" element={<KungPaoChicken />} />
        <Route path="/recipes/mapo-tofu" element={<MapoTofu />} />
        <Route path="/recipes/dim-sum" element={<DimSum />} />
        <Route path="/recipes/chow-mein" element={<ChowMein />} />
        <Route path="/recipes/fried-rice" element={<FriedRice />} />
        <Route path="/recipes/hot-pot" element={<HotPot />} />
        <Route path="/recipes/beef-and-broccoli" element={<BeefAndBroccoli />} />
        <Route path="/recipes/sweet-and-sour-pork" element={<SweetAndSourPork />} />
        <Route path="/recipes/egg-foo-young" element={<EggFooYoung />} />
        <Route path="/recipes/chinese-dumplings" element={<ChineseDumplings />} />
        <Route path="/recipes/general-tso-chicken" element={<GeneralTsoChicken />} />
        <Route path="/cities/new-york" element={<NewYork />} />
        <Route path="/cities/san-francisco" element={<SanFrancisco />} />
        <Route path="/cities/los-angeles" element={<LosAngeles />} />
        <Route path="/cities/chicago" element={<Chicago />} />
        <Route path="/cities/houston" element={<Houston />} />
        <Route path="/cities/seattle" element={<Seattle />} />
        <Route path="/cities/boston" element={<Boston />} />
        <Route path="/cities/philadelphia" element={<Philadelphia />} />
        <Route path="/cities/las-vegas" element={<LasVegas />} />
        <Route path="/cities/washington" element={<Washington />} />
      </Routes>
    </Layout>
  );
};

export default App;